// src/components/Layout/Layout.tsx
import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from '../Sidebar/Sidebar';
import styles from './Layout.module.css';
import BackgroundLayer from '../Background/BackgroundLayer';

const Layout: React.FC = () => {
  const { isAuthenticated, role } = useAuth();
  const location = useLocation();

  const shouldRedirect = !isAuthenticated && location.pathname !== '/login';
  if (shouldRedirect) return <Navigate to="/login" replace />;

  // Изоляция роли error_analyst: доступна ТОЛЬКО страница «Ошибки сервера».
  // Любой другой путь — редирект на неё (default-deny, один шлюз на все роуты).
  if (
    isAuthenticated &&
    String(role || '') === 'error_analyst' &&
    location.pathname !== '/error-watch'
  ) {
    return <Navigate to="/error-watch" replace />;
  }

  return (
    <div className={styles.layoutContainer}>
      <aside className={styles.sidebarWrap}>
        <BackgroundLayer target="side" />
        <Sidebar />
      </aside>

      <div className={styles.mainContent}>
        <BackgroundLayer target="main" />
        <div className={styles.topBarSticky}></div>

        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
